import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(27, 27, 27, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: #FFFFFF;
  border-radius: 8px;
  padding: 48px 40px;
  width: 447px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  position: relative;
`;

export const IconContainer = styled.div`
  width: 85px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const CheckIcon = styled.img`
  width: 60px;
  height: 60px;
`;

export const Title = styled.h2`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1em;
  text-align: center;
  color: #3D3D3D;
  margin: 0;
`;

export const Subtitle = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.54em;
  text-align: center;
  color: #636363;
  margin: 0;
  max-width: 320px;
`;

export const ModalMessageInfo = styled.p`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  color: #636363;
`;

export const HistoryLinkContainer = styled.span`
  font-weight: 700;
`;

export const HistoryLink = styled.span`
  cursor: pointer;
  color: #0B29FB;
  text-decoration: underline;
  font-weight: 700;

  &:hover {
    opacity: 0.8;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 24px;
  color: #636363;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    color: #3D3D3D;
  }
`;
